export enum JxtHomeBookingOptionKindEnum {
  Checkbox = 'checkbox',
  Text = 'text',
  Textarea = 'textarea',
  List = 'list',
}

export interface IJxtHomeBookingOption {
  id: number;
  name: string;
  kind: JxtHomeBookingOptionKindEnum;
  /** List: what can be chosen. */
  values: string[];
  mandatory: boolean;
  activated: boolean;
  value: string;
  /** A mandatory option left off, or without its value. */
  isInvalid: boolean;
}

export interface IJxtHomeBookingOptions {
  /** "Options de l'espace". */
  label: string;
  /** "obligatoire". */
  mandatoryLabel: string;
  /** "Choisir…" (an empty list). */
  choosePlaceholder: string;
  options: IJxtHomeBookingOption[];
  onToggle: (id: number, activated: boolean) => void;
  onValueChange: (id: number, value: string) => void;
}
